export const WIDGET_ID = "widget-search-share";
